import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { LanguageContext } from '../hooks/useLanguage';
import { aboutSection } from '../data/content';

const About: React.FC = () => {
  const { lang } = useContext(LanguageContext);

  return (
    <section
      id="about"
      style={{ background: '#0D0D0D', padding: 'clamp(60px, 8vw, 120px) 0', color: '#fff' }}
    >
      {/* Gold accent bar top */}
      <div style={{ height: '1px', background: 'linear-gradient(90deg, #C8A96E, transparent)', marginBottom: 'clamp(60px, 8vw, 120px)' }} />

      <div className="container">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '80px',
            alignItems: 'center',
          }}
          className="about-grid"
        >
          {/* Left */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
          >
            <span style={{
              fontFamily: 'var(--font-body)',
              fontSize: '11px',
              fontWeight: 600,
              letterSpacing: '5px',
              textTransform: 'uppercase',
              color: '#C8A96E',
              display: 'block',
              marginBottom: '12px',
            }}>
              {aboutSection.label[lang]}
            </span>
            <h2 style={{
              fontFamily: 'var(--font-display)',
              fontSize: 'clamp(26px, 3.5vw, 48px)',
              fontWeight: 700,
              letterSpacing: '-0.5px',
              lineHeight: 1.1,
              color: '#FFFFFF',
              marginBottom: '32px',
            }}>
              {aboutSection.title[lang]}
            </h2>
            <p style={{
              fontFamily: 'var(--font-body)',
              fontSize: 'clamp(15px, 1.2vw, 18px)',
              color: '#AAAAAA',
              lineHeight: 1.8,
              marginBottom: '56px',
            }}>
              {aboutSection.description[lang]}
            </p>

            {/* Stats */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '32px',
            }}>
              {aboutSection.stats.map((stat, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.15 }}
                  style={{
                    borderLeft: '3px solid #C8A96E',
                    paddingLeft: '16px',
                  }}
                >
                  <div style={{
                    fontFamily: 'var(--font-mono)',
                    fontSize: 'clamp(22px, 2.5vw, 32px)',
                    fontWeight: 400,
                    color: '#C8A96E',
                    lineHeight: 1,
                    letterSpacing: '1px',
                  }}>
                    {stat.value}
                  </div>
                  <div style={{
                    fontFamily: 'var(--font-body)',
                    fontSize: '13px',
                    fontWeight: 400,
                    color: '#555555',
                    letterSpacing: '0.5px',
                    marginTop: '6px',
                  }}>
                    {stat.label[lang]}
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Right image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.92 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            style={{ position: 'relative' }}
          >
            <img
              src="https://images.unsplash.com/photo-1705579604303-3086e4162d34?auto=format&fit=crop&w=900&q=80"
              alt="Villa automatizada Vatio Central"
              style={{
                width: '100%',
                height: '600px',
                objectFit: 'cover',
              }}
            />
            {/* Gold corner accent */}
            <div style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: '3px',
              background: 'linear-gradient(90deg, #C8A96E, #E8C98A)',
            }} />
            <motion.div
              initial={{ opacity: 0, x: 20, y: 20 }}
              whileInView={{ opacity: 1, x: 0, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5 }}
              style={{
                position: 'absolute',
                bottom: '32px',
                right: '32px',
                background: 'rgba(13,13,13,0.9)',
                border: '1px solid rgba(200,169,110,0.3)',
                color: '#C8A96E',
                padding: '16px 24px',
                fontFamily: 'var(--font-body)',
                fontSize: '11px',
                fontWeight: 700,
                letterSpacing: '3px',
                textTransform: 'uppercase',
              }}
            >
              KNX CERTIFIED ✓
            </motion.div>
          </motion.div>
        </div>
      </div>
      <style>{`
        @media (max-width: 768px) {
          .about-grid { grid-template-columns: 1fr !important; gap: 48px !important; }
        }
      `}</style>
    </section>
  );
};

export default About;
